import * as React from 'react';
import {
  BaseModalLayoutProps,
  FootnoteProps,
  ModalSkin,
} from '../BaseModalLayout';
import { ButtonProps, ButtonSize } from '../Button';

export interface MessageModalLayoutProps extends BaseModalLayoutProps {
  /** Sets text title for the modal; can be used in conjunction with other components. */
  title?: string | React.ReactNode;
  /** Sets text subtitle for the modal; can be used in conjunction with other components. */
  subtitle?: string | React.ReactNode;
  /** Contains modal’s message in its middle area. <MessageModalLayout/> children are passed as content, too. */
  content?: string | React.ReactNode;
  /** Sets text label for the primary button. */
  primaryButtonText?: string | React.ReactNode;
  /** Passes on any \<Button/\> properties on the primary button. */
  primaryButtonProps?: Omit<ButtonProps, 'internalDataHook'>;
  /** Defines a call-back function after user clicks on the primary button. */
  primaryButtonOnClick?(): void;
  /** Sets text label for the secondary button. */
  secondaryButtonText?: string | React.ReactNode;
  /** Passes on any \<Button/\> properties on the secondary button. */
  secondaryButtonProps?: Omit<ButtonProps, 'internalDataHook'>;
  /** Defines a call-back function after user clicks on the secondary button. */
  secondaryButtonOnClick?(): void;
  /** Determines the action buttons size. */
  actionsSize?: ButtonSize;
  /** Contains a checkbox or other components at the start of the footer. */
  sideActions?: React.ReactNode;
  /** Renders supplementary text or other components at the bottom of the modal. */
  footnote?: React.ReactNode;
  /** Sets the look and feel of the footnote. */
  footnoteSkin?: FootnoteProps['skin'];
  /** Contains a 120x120 px illustration at the left side of the modal. */
  illustration?: string | React.ReactNode;
  /** @deprecated use skin prop instead. */
  theme?: ModalSkin;
}
